// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__os6By"};